import { render, staticRenderFns } from "./rstoreLoginInfo__form.vue?vue&type=template&id=534041e5"
import script from "./rstoreLoginInfo__form.vue?vue&type=script&lang=js"
export * from "./rstoreLoginInfo__form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports